import { render } from "./ModalTableManagement.vue?vue&type=template&id=20c43670"
import script from "./ModalTableManagement.vue?vue&type=script&lang=js"
export * from "./ModalTableManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__